async function createVisor(visorId, pnc) {
  const url = `${process.env.REACT_APP_API_URL}/Visor/CreateVisor?visorId=${visorId}&pnc=${pnc}`;
  const response = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    }
  });

  const responseBody = await response.text();

  if (response.status === 401) {
      // Optional: let AuthContext know so it can logout
      window.dispatchEvent(new Event('app:unauthorized'));
      throw new Error('Unauthorized');
    }

  if (!response.ok) {
    let errorMessage = `HTTP error! status: ${response.status}`;
    try {
      const errorResponse = JSON.parse(responseBody);
      errorMessage = errorResponse.message || errorMessage;
    } catch (e) {
      // Failed to parse error response, keep default error message
    }
    throw new Error(errorMessage);
  }

  try {
    return JSON.parse(responseBody);
  } catch (error) {
    throw new Error("Failed to parse response as JSON: " + error.message);
  }
}

async function getVisorIdList() {
  const url = `${process.env.REACT_APP_API_URL}/Visor/GetVisorIdList`;

  const response = await fetch(url, {
    method: 'GET',
    credentials: 'include',
  });

  const responseBody = await response.text();

  if (response.status === 401) {
      // Optional: let AuthContext know so it can logout
      window.dispatchEvent(new Event('app:unauthorized'));
      throw new Error('Unauthorized');
    }
    
  if (!response.ok) {
    let errorMessage = `HTTP error! status: ${response.status}`;
    try {
      const errorResponse = JSON.parse(responseBody);
      errorMessage = errorResponse.message || errorMessage;
    } catch (e) {}
    throw new Error(errorMessage);
  }

  try {
    return JSON.parse(responseBody);
  } catch (error) {
    throw new Error("Failed to parse response as JSON: " + error.message);
  }
}

export default { createVisor, getVisorIdList };